import React, { useState, useEffect, useRef, useCallback } from 'react'
import Header from '../Header/Header.js'
import Handsontable from "handsontable";
import { HotTable } from '@handsontable/react-wrapper';
import { getData, deleteData, putData, postData } from '../../FetchApiServices.js';
import Loader from '../Assets/Loader.js';
import FormModal from '../Forms/FormModal.js';
import ConfirmationModal from '../Assets/ConfirmationModal.js';
import Alert from '../Assets/Alerts.js';


const ViewSections = () => {
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ section_name: '' });
    const [modalTitle, setModalTitle] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const hotTableRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState({ type: '', message: '' });

    const fetchData = useCallback(async () => {
        setLoading(true);
        const response = await getData('sections');
        setData(response.data.data)
        generateSerialNo(response.data.data);
        setLoading(false);
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const generateSerialNo = (data) => {
        let serialNo = 1;
        return data.map(user => {
            user.serial_no = serialNo;
            serialNo++;
            return data;
        });
    }

    useEffect(() => {
        if (alert.message) {
            const timer = setTimeout(() => {
                setAlert({ type: '', message: '' });
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [alert]);


    const actionRenderer = (_instance, td, row, _col, _prop, _value, _cellProperties) => {
        // Clear the cell before adding custom content
        Handsontable.dom.empty(td);

        // Create "Edit" button
        const editButton = document.createElement("i");
        editButton.innerHTML = "<span class='action-icons'>Edit</span>";
        editButton.className = "fa fa-pencil mx-2 ft-6 text-primary";
        editButton.onclick = () => handleOpenModal(row, true);

        // Create "Delete" button
        const deleteButton = document.createElement("i");
        deleteButton.innerHTML = "<span class='action-icons'>Delete</span>";
        deleteButton.className = "fa fa-trash mx-2 ft-6 text-danger";
        deleteButton.onclick = () => handleDelete(row);

        // Append buttons to the cell
        td.appendChild(editButton);
        td.appendChild(deleteButton);

        return td;
    };


    const handleOpenModal = (row, isEdit) => {
        if (isEdit) {
            if (hotTableRef.current?.hotInstance) {
                const rowData = hotTableRef.current.hotInstance.getDataAtRow(row);
                setFormData({ section_name: rowData[1] });
                setSelectedRow(rowData[2]);
                setModalTitle('Edit Section');
                setShowModal(true);
                setIsEdit(true);
            }
        }
        else {
            setFormData({ section_name: "" });
            setModalTitle('Add Section');
            setIsEdit(false);
            setShowModal(true);
        }
    };



    const handleDelete = (row) => {
        if (hotTableRef.current?.hotInstance) {
            const rowData = hotTableRef.current.hotInstance.getDataAtRow(row);

            setSelectedRow(rowData[2]); // Assuming sub_event_id is at index 2
            setShowConfirmationModal(true);
        } else {
            console.error("hotTableRef is not initialized");
        }
    };

    const confirmDelete = async () => {
        if (selectedRow) {
            const response = await deleteData(`sections/${selectedRow}`);
            if (response) {
                fetchData();
            }
            setShowConfirmationModal(false);
            setSelectedRow(null);
        }
    };

    const handleSubmit = async (formData) => {
        let response;
        if (isEdit) {
            response = await putData(`sections/${selectedRow}`, formData);
        }
        else {
            response = await postData('sections', formData);
        }
        if (response.error) {
            setAlert({ type: 'error', message: response.error.message });
        } else {
            setAlert({ type: 'success', message: response.data.message });
            handleCloseModal();
        }

    };

    const fields = [
        { name: 'section_name', label: 'Section Name', value: formData.section_name, required: true, placeholder: 'Enter Section Name' }
    ];

    const handleCloseModal = () => {
        setShowModal(false);
        fetchData();
    };

    const button = <button className="btn-success btn btn-sm" onClick={() => handleOpenModal(null, false)}>Add Section</button>

    return (
        <>
            {loading && <Loader />}
            {alert.message && <Alert type={alert.type} message={alert.message} />}
            {showModal && <FormModal showModal={showModal} setShowModal={setShowModal} title={modalTitle} fields={fields} handleSubmit={handleSubmit} />}
            {showConfirmationModal && <ConfirmationModal showModal={showConfirmationModal} setShowModal={setShowConfirmationModal} title="Delete Section" message="Are you sure you want to delete this Section?" onConfirm={confirmDelete} />}
            <Header title="Sections" button={button} />
            <div className="container-fluid " >
                <div className="row justify-content-center" >
                    <div className="col-12 listing-view">
                        <HotTable
                            data={data}
                            ref={hotTableRef}

                            columns={[
                                { data: 'serial_no', title: 'S.No.', type: 'text', readOnly: true, dropdownMenu: false, width: 10 },
                                {
                                    title: 'Section Name', type: 'text', data: 'section_name', className: 'notranslate'
                                },
                                { title: 'Action', type: 'text', data: 'section_id', readOnly: true, renderer: actionRenderer, width: 20, dropdownMenu: false }
                            ]}

                            filters={true}
                            dropdownMenu={true}
                            manualColumnResize={true}
                            manualColumnMove={true}
                            manualRowMove={true}
                            autoWrapRow={true}
                            autoWrapCol={true}
                            licenseKey={process.env.REACT_APP_EXCEL_LICENSE_KEY}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default ViewSections
